import React, { useEffect, useState, memo } from "react";
import { Button, Col, Row, Image, Badge } from "react-bootstrap";
import New from "../../assets/images/new.png";
import ShopImage from "../../assets/images/default-shop.png";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import DefaultProduct from "../../assets/images/default-product.png";
import { faHeart as faHeartOutline } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./ProductList.style";
import { base_url } from "../../Api/ApiConst";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Redux/Store/Store";
import { SET_SELECTED_PRODUCT } from "../../Redux/productId";
import { useNavigate } from "react-router-dom";
import {
  Add_To_Cart,
  Remove_From_Cart,
  Update_Cart,
  User_Last_Viewed,
  View_Cart,
} from "../../Api";
import { toast } from "react-toastify";
import { VIEW_CART } from "../../Redux/Cart";
import {
  AddToWishList,
  fetchWishlist,
  handleRemoveFromWishlist,
} from "../../Utils/wishListUtils";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
import { useTranslation } from "react-i18next";
import { getOutOfStockProduct } from "../../Utils/OutOfStock";
import { getQuantity, handleShowInventoryLabel } from "../../Utils/cartUtils";
import { SET_SELECTED_STORE_ID } from "../../Redux/storeSlice";
import NoDataFound from "../NoDataFound/NoDataFound";
// login modals
import LoginPhoneNumber from "../LoginModal";
import VerifyDetails from "../LoginModal/VerifyDetailsModal";
import { Modal } from "react-bootstrap";


import { add } from "lodash";
const isWithin48Hours = (lastProductDate: string): boolean => {
  const currentDate = new Date();
  const productCreatedDate = new Date(lastProductDate);
  const timeDiff = currentDate.getTime() - productCreatedDate.getTime();
  const hoursDiff = timeDiff / (1000 * 60 * 60); // Convert to hours
  return hoursDiff <= 48;
};

export interface ProductListProps {
  selectedSubcategory: string;
  products: any[];
}

const ProductList: React.FC<ProductListProps> = memo(
  ({ selectedSubcategory, products }) => {
    const { t, i18n } = useTranslation();
    const languageId: any = useSelector((state: RootState) => state.lan);
    const [userToken, setUserToken] = React.useState<string | null>("");
    const [currency, setCurrency] = useState("NPR");

    // login modal states
    const [loginFeatureModal, setLoginFeatureModal] = useState(false);
    const [verifyDetailsModal, setVerifyDetailsModal] = useState(false);
    const [productId, setProductId] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [state, setState] = useState<boolean>();
    const wishlist: any = useSelector(
      (state: RootState) => state.User.productIdInWishList,
    );
    const outOfstock = useSelector(
      (state: RootState) => state.offer.OutOfStock,
    );
    const cartData = useSelector((state: RootState) => state.Cart.View_Cart);
    useEffect(() => {
      setUserToken(localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN));
      getOutOfStockProduct();
    }, []);

    useEffect(() => {
      fetchWishlist();
    }, [userToken]);

    if (products.length === 0) {
      return (
        <NoDataFound title={t("commonHeader.noProductsFoundInYourArea")} />
      );
    }

    const handleClick = (id: any) => {
      dispatch(SET_SELECTED_PRODUCT(id));
      {
        userToken && User_Last_Viewed(id);
      }
      const product = products?.find((p) => p.id === id);
      navigate(`/product/${product?.PRDSlug ?? id}`);
    };

    const handleCart = (
      id: any,
      storeId: any,
      store_name: any,
      language_data: any,
      store_logo: any,
      store_rating: any,
      minimum: any,
      main_cat_name: any,
      opening_time: any,
      closing_time: any,
    ) => {
      const isFoodDelivery = main_cat_name === "Food Delivery";
      const isStoreClosed = !opening_time || !closing_time; // Check if opening/closing times exist

      if (isFoodDelivery && isStoreClosed) {
        toast.error("Sorry, this shop is currently closed.");
        return;
      }

      const addToCart = async () => {
        try {
          const response = await Add_To_Cart(id, currency, minimum);
          if (response && response.status === 200) {
            localStorage.setItem(STORAGE_CONSTANTS.SHOP_ID, storeId);
            dispatch(SET_SELECTED_STORE_ID(storeId));
            toast.success(response["data"]["message"]);
            localStorage.setItem(
              STORAGE_CONSTANTS.ORDER_ID,
              response?.data?.order_id,
            );
            const state = {
              store_name: store_name,
              language_data: language_data,
              store_logo: store_logo,
              storeId: storeId,
              store_rating: store_rating,
            };
            navigate("/store", { state: state });
            const Cartresponse = await View_Cart();
            if (Cartresponse && Cartresponse.status === 200) {
              dispatch(VIEW_CART(Cartresponse.data));
            }
          } else {
            toast.error(response["data"]["message"]);
          }
        } catch (error: any) {
          console.log("Error occurred:", error);
        }
      };
      addToCart();
    };

    const incrementQuantity = (id: any, ProductQuantity: any) => {
      const Update_product = async () => {
        try {
          const response = await Update_Cart(
            currency,
            ProductQuantity + 1,
            id,
            cartData?.cart_details?.order?.id,
          );
          if (response && response.status === 200) {
            const Cartresponse = await View_Cart();
            if (Cartresponse && Cartresponse.status === 200) {
              dispatch(VIEW_CART(Cartresponse.data));
            }
            setState(true);
            if (response.data.error) {
              toast.error(response["data"]["error"]);
            } else {
              toast.success(response["data"]["message"]);
            } // setStores(response.data.store_list);
          } else {
            console.log("Error fetching Cart details");
          }
        } catch (error: any) {
          console.log("Error fetching Cart details", error);
          toast.error(error?.response?.data?.message);
        }
      };
      Update_product();
    };

    const decrementQuantity = async (
      id: any,
      ProductQuantity: any,
      minimum: any,
    ) => {
      if (ProductQuantity > minimum) {
        const Update_product = async () => {
          try {
            const response = await Update_Cart(
              currency,
              ProductQuantity - 1,
              id,
              cartData?.cart_details?.order?.id,
            );
            if (response && response.status === 200) {
              const Cartresponse = await View_Cart();
              if (Cartresponse && Cartresponse.status === 200) {
                dispatch(VIEW_CART(Cartresponse.data));
              }
              setState(true);
              toast.success(response["data"]["message"]);
            } else {
              console.log("Error fetching Cart details");
            }
          } catch (error: any) {
            console.log("Error fetching Cart details", error);
            toast.error(error.response.data.message);
          }
        };
        Update_product();
      } else if (ProductQuantity == minimum) {
        try {
          const response = await Remove_From_Cart(
            currency,
            id,
            cartData?.cart_details?.order?.id,
          );
          if (response && response.status === 200) {
            const Cartresponse = await View_Cart();
            if (Cartresponse && Cartresponse.status === 200) {
              dispatch(VIEW_CART(Cartresponse.data));
            }
            setState(false);
            toast.success(response["data"]["message"]);
          } else {
            console.log("Error fetching Cart details");
          }
        } catch (error: any) {
          toast.error(error.response.data.message);
        }
      }
    };

    const manageTextLength = (text: string): string => {
      if (text.length > 40) {
        let newText = text.slice(0, 30) + "...";
        return newText;
      } else {
        return text;
      }
    };
    const manageBrandTextLength = (text: string): string => {
      if (text.length > 11) {
        let newText = text.slice(0, 10) + "...";
        return newText;
      } else {
        return text;
      }
    };

    const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
    return (
      <div>
        <Row>
          {products &&
            products.map((product, index) => {
              const ProductQuantity = getQuantity(
                product?.product_vendor_store?.id,
                product?.id,
              );
              const isRecent = isWithin48Hours(product.date);
              const store = product.product_vendor_store;
              const isStoreClosed = !store.opening_time || !store.closing_time;
              return (
                <Col key={index} className="col-sm-3">
                  <div
                    style={styles.product}
                    className={`product-card ${
                      isStoreClosed ? "grayed-out" : ""
                    }`}
                  >
                    {isRecent && (
                      <Image src={New} className="mx-2 new-arrival" />
                    )}
                    <div
                      style={styles.imageWrap}
                      key={product.id}
                      className="product-image-wrap"
                    >
                      {product?.current_price &&
                        product?.current_price.discount_type && (
                          <div
                            style={styles.offerBadgeWrap}
                            className="offer-badge"
                          >
                            <div style={styles.arrowRight}></div>
                            <p style={styles.text} className="mb-0">
                              {product.current_price.discount_type === "amount"
                                ? `${product.current_price.discount_val} Rs`
                                : `${product.current_price.discount_val} %`}
                              <br /> OFF
                            </p>
                          </div>
                        )}

                      {product.current_price &&
                        product.current_price.discount_type && (
                          <>
                            {product.current_price.offer_valid_to === today && (
                              <Badge bg="danger">
                                Ends <br></br>Today
                              </Badge>
                            )}
                          </>
                        )}

                      <Image
                        className="product-image"
                        src={`${base_url}${product.product_image}`}
                        // src={`${product.product_image}`}
                        style={styles.productImage}
                        onClick={() => handleClick(product.id)}
                        onError={(e) => (e.currentTarget.src = DefaultProduct)} // Replace with default image
                      />
                      <div style={styles.heartImageWrap}>
                        <FontAwesomeIcon
                          icon={
                            wishlist.includes(product?.id)
                              ? (faHeart as any)
                              : (faHeartOutline as any)
                          }

                          // moved the onClick function to handle the login modal flow

                          onClick={() => {
                            if (!userToken) {
                              toast.error("Login to add products to wishlist");
                              setLoginFeatureModal(true);
                              setProductId(product?.id);
                              return;
                            }

                            if (wishlist.includes(product?.id)) {
                              handleRemoveFromWishlist(product?.id);
                            } else {
                              AddToWishList(product?.id);
                            }
                          }}
                        />
                      </div>
                    </div>
                    {product?.current_price?.offer_type === "bogo" ? (
                      <div
                        className="bogo-wrap"
                        title={`Buy ${
                          product.current_price.buy_quantity
                        }, get ${product.current_price.free_quantity} ${
                          product.current_price.free_product.length > 7
                            ? product.current_price.free_product
                            : product.current_price.free_product
                        } Free`}
                      >
                        {`Buy ${product.current_price.buy_quantity}, get ${
                          product.current_price.free_quantity
                        } ${
                          product.current_price.free_product.length > 7
                            ? product.current_price.free_product.substring(
                                0,
                                5,
                              ) + "..."
                            : product.current_price.free_product
                        } Free`}
                      </div>
                    ) : (
                      <div style={{ minHeight: 25 }}></div>
                    )}

                    <div
                      style={styles.productContent}
                      className="productContent"
                    >
                      <div className="d-flex align-items-center mb-1 shopInfo">
                        <div
                          className="shopImageWrap"
                          style={styles.shopIconWrap}
                        >
                          <Image
                            src={
                              product?.product_vendor_store?.logo
                                ? `${base_url}/${product?.product_vendor_store?.logo}`
                                : ShopImage
                            }
                            style={styles.shopIcon}
                          />
                        </div>
                        <h2 style={styles.shopName} className="mb-0 shopName">
                          {product?.product_vendor_store?.language_data
                            ?.length === 0
                            ? product?.product_vendor_store?.store_name
                            : languageId === "ne"
                            ? product?.product_vendor_store?.language_data[0]
                                ?.store_name
                            : product?.product_vendor_store?.store_name ||
                              "Unknown Store"}
                        </h2>
                      </div>
                      <h2
                        style={styles.productName}
                        onClick={() => handleClick(product.id)}
                        className="product-name"
                      >
                        {manageTextLength(
                          product?.language_data?.length === 0
                            ? product?.product_name
                            : languageId === "ne"
                            ? product?.language_data[0]?.product_name
                            : product?.product_name,
                        )}
                      </h2>
                      <div className="d-flex align-items-center justify-content-between wt-brand">
                        <h3 style={styles.quantity}>
                          {product.PRDWeight}
                          {product.unit_measure}
                        </h3>
                        <div>
                          {product?.brand && (
                            <h3 className="brandName">
                              {manageBrandTextLength(product.brand)}
                            </h3>
                          )}
                        </div>
                      </div>
                      <div style={styles.priceWrap} className="priceWrap">
                        {product.current_price ? (
                          <span
                            style={styles.offerPrice}
                            className="offerPrice"
                          >
                            रु
                            {parseFloat(
                              product.current_price.current_price,
                            ).toFixed(2)}
                          </span>
                        ) : (
                          <span style={styles.offerPrice} className="price">
                            रु{parseFloat(product.PRDPrice).toFixed(2)}
                          </span>
                        )}
                        {product.current_price && (
                          <span style={styles.price} className="price">
                            रु{product.PRDPrice}
                          </span>
                        )}
                      </div>
                      <div className="d-grid gap-2">
                        {outOfstock.length > 0 &&
                        outOfstock.includes(product?.id) ? (
                          <Button
                            style={styles.btnAdd}
                            size="lg"
                            disabled
                            className="btn-outOfStock"
                          >
                            {t("commonHeader.outOfStock")}
                          </Button>
                        ) : ProductQuantity > 0 ? (
                          <div className="add-to-cart">
                            <button
                              className="quantity-button"
                              onClick={() =>
                                decrementQuantity(
                                  product?.id,
                                  ProductQuantity,
                                  product?.minimum_qty,
                                )
                              }
                            >
                              -
                            </button>
                            <span className="quantity">{ProductQuantity}</span>
                            <button
                              className="quantity-button add"
                              onClick={() =>
                                incrementQuantity(product?.id, ProductQuantity)
                              }
                              disabled={product?.maximum_qty == ProductQuantity}
                            >
                              +
                            </button>
                          </div>
                        ) : (
                          <Button
                            style={styles.btnAdd}
                            size="lg"
                            onClick={() => {
                              const storeName =
                                product.language_data &&
                                product.language_data.length > 0
                                  ? product.language_data[0].store_name
                                  : undefined;
                              handleCart(
                                product?.id,
                                product?.product_vendor_store?.id,
                                product.product_vendor_store?.store_name,
                                storeName,
                                product?.product_vendor_store?.logo,
                                product?.product_vendor_store?.store_rating,
                                product?.minimum_qty,
                                product?.product_subcategory?.main_cat_name, // <-- Fix: Added main category name
                                product?.product_vendor_store?.opening_time, // <-- Fix: Added opening time
                                product?.product_vendor_store?.closing_time, // <-- Fix: Added closing time
                              );
                            }}
                          >
                            {t("commonHeader.add")}
                          </Button>
                        )}
                      </div>
                      {ProductQuantity > 0 && (
                        <p
                          style={{
                            color: "red",
                            fontSize: "small",
                            marginLeft: "2.5rem",
                          }}
                        >
                          {handleShowInventoryLabel(
                            product?.minimum_qty,
                            product?.maximum_qty,
                            product?.available,
                            ProductQuantity,
                          )}
                        </p>
                      )}
                    </div>
                  </div>
                </Col>
              );
            })}
        </Row>
        {/* modal for login flow */}
        <div>
          <Modal
            show={loginFeatureModal}
            onHide={() => setLoginFeatureModal(false)}
            centered
          >
            <Modal.Body>
              <LoginPhoneNumber
                setVerifyDetailsModal={setVerifyDetailsModal}
                setLoginFeatureModal={setLoginFeatureModal}
              />
            </Modal.Body>
          </Modal>
          <Modal
            show={verifyDetailsModal}
            onHide={() => setVerifyDetailsModal(false)}
            centered
          >
            <Modal.Body>
              <VerifyDetails
                setVerifyDetailsModal={setVerifyDetailsModal}
                productId={productId}
              />
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  },
);

export default ProductList;
